<script>
  import Spinner from "./Spinner.svelte";
  export let isLoading = true;
  export let error = false;
  export let lang = "en";
</script>

{#if isLoading}
  <div class="loading">
    {#if error}
      <div class="error">
        {#if lang === "es"}
          <p>
            😥 Lo sentimos, no pudimos cargar la información del link. Intenta
            de nuevo mas tarde
          </p>
        {:else}
          <p>
            😥 We are sorry, we couldn't load the link information. Try again
            later.
          </p>
        {/if}
      </div>
    {:else}
      <Spinner />
    {/if}
  </div>
{:else}
  <slot />
{/if}

<style>
  .loading {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .error {
    text-align: center;
    padding: 1rem;
  }
</style>
